import {
  Button,
  DialogActions,
  DialogContent,
  Icons,
  Spinner,
  useSwipeableViews,
  CloseDialogButton,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type Props = {
  onClose: () => void;
};

export const EnablingSlide = ({ onClose }: Props) => {
  const swipeableViewsCtx = useSwipeableViews();

  return (
    <Stack position="relative">
      <CloseDialogButton onClose={onClose} />
      <DialogContent>
        <Stack direction="row" gap={12}>
          <Spinner color="secondary" size={32} />
          <Stack gap={4}>
            <Typography variant="h6">
              Enabling Kubernetes & cloud security
            </Typography>
            <Typography variant="P12R" color="textSecondary">
              Closing this dialog will not affect the process.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          py: 16,
          borderTop: tokens.theme.border.structural.neutralSubtle,
          justifyContent: 'space-between',
        }}
      >
        <Button
          variant="ghost"
          size="md"
          startIcon={<Icons.ArrowLeft />}
          onClick={() => swipeableViewsCtx?.goToPreviousSlide()}
          testId="back-step-button"
        >
          Back
        </Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Stack>
  );
};
